module.exports = __webpack_public_path__ + "img/octopus.36cadfb4.png";